import { routerReducer } from 'react-router-redux';
import { combineReducers } from 'redux';
import { IAppState } from 'src/models/state';
import { loginReducer } from './login/reducer';
import { reportManagerReducer } from './manager/reducer';
import { reportReducer } from './report/reducer';

// #region -------------- Reducer -------------------------------------------------------------------

export const rootReducer = combineReducers<IAppState>({
  router: routerReducer,
  login: loginReducer,
  report: reportReducer,
  reportManager: reportManagerReducer,
});

// #endregion
